export const API_LIB = {
    AUTHENTICATION_LOGIN: 'authentication/login', //login
    AUTHENTICATION_LOGOUT: 'authentication/logout', //logout
    AUTHENTICATION_SIGNUP_STEP_ONE: 'authentication/signup-step1', //step-one
    AUTHENTICATION_SIGNUP_STEP_TWO: 'authentication/signup-step2', //step-two
    AUTHENTICATION_UPDATE_ACCOUNT: 'authentication/update-account', //update-account
    EXTERNAL_CSRF_TOKEN: 'external/generate-csrf-token', //csrf token
    CASHIER_DEPOSIT: 'cashier/deposit', //deposit cashier
    LOBBY_CATEGORIES: `lobby/get-lobbies-categories`, //get categories
    LOBBY_DASHBOARD: (lobbyName: string) => `lobby/${lobbyName}/get-dashboard-info`, // dashboard api
    LOBBY_FAVOURITE_ADD: 'lobby/add-favourite-game', //Add favourite games
    LOBBY_FAVOURITE_REMOVE: 'lobby/remove-favourite-game', //Remove favourite games
    LOBBY_LAST_PLAYED: (lobbyName: string) => `lobby/${lobbyName}/recent`, //get recent games
    LOBBY_LIVEDEALER_URL: 'games/launch-lobby', // get live dealer url
    LOBBY_TAGS: 'lobby/get-tags'
};